import React from "react";
import { Link } from "react-router-dom";
import { OWNED_LISTINGS_VERIFICATION } from "../api/classicSiteMemberApi";
import { CLASSIC_SITE_BASE, SURFACE_STATUS } from "../classicSite.constants";
import BlockedSurface from "./BlockedSurface";

/**
 * Owned listings summary — Phase 3: blocked until owner-scoped API exists.
 */
export default function OwnedListingsPanel({ compact = false }) {
  if (OWNED_LISTINGS_VERIFICATION.status !== "blocked") {
    return null;
  }

  if (compact) {
    return (
      <BlockedSurface
        title="My listings"
        status={SURFACE_STATUS.BLOCKED}
        djangoUrl={OWNED_LISTINGS_VERIFICATION.legacyUrl}
        reason="Owned listing summary requires an owner-scoped listings API. The hoodie listings endpoint returns public enabled listings only."
        apiNote={
          <>
            Verified: no <code>?mine</code> filter.{" "}
            <Link to={`${CLASSIC_SITE_BASE}/member/listings`}>Details →</Link>
          </>
        }
        specRef="classic-site-react-api-gap-register-v1.md — owned listings"
      />
    );
  }

  return (
    <section className="cs-owned-listings">
      <h2 className="cs-panel__title">My listings</h2>
      <BlockedSurface
        title="Owned listing summary unavailable"
        status={SURFACE_STATUS.BLOCKED}
        djangoUrl="/member/listings/new/"
        reason="GET /api/hoodie/listings/ cannot safely return the current member's owned listings. Use legacy member listing management for now."
        specRef="classic-site-react-api-gap-register-v1.md"
      >
        <div className="cs-verification">
          <p className="cs-verification__heading">API verification (Django source audit)</p>
          <ul className="cs-verification__list">
            {OWNED_LISTINGS_VERIFICATION.reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
          <p className="cs-verification__meta">
            Endpoint: <code>{OWNED_LISTINGS_VERIFICATION.endpoint}</code>
            {" · "}
            Verified: <code>{OWNED_LISTINGS_VERIFICATION.verified}</code>
          </p>
        </div>
        <p className="cs-legacy-card__phase">
          Listing create/edit/delete: Phase 4+ or manage in Django.
        </p>
        <a
          className="cs-legacy-card__link"
          href="/member/accounts/profile/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legacy account overview (listing count) →
        </a>
      </BlockedSurface>
    </section>
  );
}
